const messages = {
    en: {
        delivery: {
            payment: {
                title: 'Payment',
                receiptRequired: 'Ten en cuenta que necesitaremos que adjuntes el comprobante de transferencia en formato de imagen o pdf',
                method: {
                    CASH: "Cash",
                    DEBIT: "Debit",
                    BANK_TRANSFER: "Bank Transfer",
                    MP_TRANSFER: "Mercado Pago Transfer",
                    RAPPI: "Rappi",
                    PEDIDOS_YA: "PedidosYa",
                },
                paid: 'Paid',
                discount: 'Discount',
                totalDiscount: 'Discount',
            }
        }
    },
    es: {
        delivery: {
            payment: {
                title: 'Pago',
                receiptRequired: 'Ten en cuenta que necesitaremos que adjuntes el comprobante de transferencia en formato de imagen o pdf',
                method: {
                    CASH: "Efectivo",
                    DEBIT: "Débito",
                    BANK_TRANSFER: "Transferencia bancaria",
                    MP_TRANSFER: "Transferencia Mercado Pago",
                    RAPPI: "Rappi",
                    PEDIDOS_YA: "PedidosYa",

                },
                paid: 'Pagado',
                discount: 'Descuento',
                totalDiscount: 'Descuento',
            }
        }
    },
    pt: {
        delivery: {
            payment: {
                title: 'Método de pago',
                receiptRequired: 'Ten en cuenta que necesitaremos que adjuntes el comprobante de transferencia en formato de imagen o pdf',
                method: {
                    CASH: "Efectivo",
                    DEBIT: "Débito",
                    BANK_TRANSFER: "Transferencia bancaria",
                    MP_TRANSFER: "Transferencia Mercado Pago",

                },
                paid: 'pago',
                discount: 'Discount',
                totalDiscount: 'Descuento'
            }
        }
    }

}


export default messages
